import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installImageSafety } from "@/lib/img";

installImageSafety();

// Silence benign "ResizeObserver loop …" warnings (emitted by some Radix UI
// Select/Dialog components) so they don't trigger CRA's red dev error overlay.
const RESIZE_OBSERVER_ERR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e.message && RESIZE_OBSERVER_ERR.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);  // capture phase: run before CRA's error-overlay listener

const rootEl = document.getElementById("root");
// react-snap prerenders static HTML at build time; hydrate it when present, otherwise
// do a normal client render (dev, or if prerendering was skipped on the build host).
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootEl,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
